/*

  Sets up Swiper for the hero slider on the home page
  @see https://swiperjs.com/get-started

*/

import SwiperCore, {
  A11y,
  Autoplay,
  EffectFade,
  Navigation,
} from 'swiper/core';

SwiperCore.use([A11y, Autoplay, EffectFade, Navigation]);

const heroSlider = new SwiperCore('.c-hero-slider', {
  centeredSlides: true,
  effect: 'fade',
  loop: true,
  spaceBetween: 0,
  a11y: {
    enabled: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  fadeEffect: {
    crossFade: true,
  },
});

export default heroSlider;
